module.exports = __webpack_public_path__ + "img/pt.eba93d33.png";